import React, { useState, useEffect } from "react";
import projectServices from "../Projects/projectServices"
import ProjectSlider from "components/Projects/projectSlider";

export default function ProjectIndicators(param: any) {


 //    console.log(param)
    return (
        <>
        {(param.type=="horizontal") && <div className="ws-12">
            <div className="w-14 pm">
                <div className="topFrame topFrame_paleBlue ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">
                        Period Balance
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.beginBalance}</span>
                        <div ><ProjectSlider type="period_balance" up={true} value={param.indicator.beginBalance} data={param.project} /></div>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_darkBlue ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">Last
                        Payment
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.lastPayment}</span>
                        <div ><ProjectSlider type="payments" up={true} value={param.indicator.lastPayment} data={param.project} /></div>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_turquoise ws-12 pull-left">
                    <label className="ws-12 text-left mts text-bold">Opening
                        Balance
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12">{param.indicator.openingBalance}</span>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_purple ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">
                        Earnings
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.totalEarnings}</span>
                        <div ><ProjectSlider type="Earnings" up={true} value={param.indicator.totalEarnings} data={param.project} /></div>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_orange ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">
                        Recoupables
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.totalCosts}</span>
                        <div ><ProjectSlider type="costs" up={true} value={param.indicator.totalCosts} data={param.project} /></div>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_green ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">
                        Adjustments
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.totalAdjustments}</span>
                        <div ><ProjectSlider type="adjustments" up={true} value={param.indicator.totalAdjustments} data={param.project} /></div>
                    </div>
                </div>
            </div>

            <div className="w-14 pm">
                <div className="topFrame topFrame_paleBlue ws-12 pull-left ">
                    <label className="ws-12 text-left mts text-bold">
                        Total Balance
                    </label>
                    <div className="label-entries ws-12 text-m mtl mb text-right text-bold">
                        <span className="ws-12 hide">{param.indicator.endBalance}</span>
                        <div ><ProjectSlider type="totalProject" up={true} value={param.indicator.endBalance} data={param.project} /></div>
                    </div>
                </div>
            </div>
        </div>}
        
        {(param.type=="vertical") && <div>
            
        </div>}
        </>
    );
}